var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-js-responsive-container vjs-hd"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"autoplay":_vm.shouldAutoPlay,"controls":"","preload":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }